<template>
  <router-link
    :to="to"
    class="flex items-center justify-center gap-2 px-4 py-1 font-normal text-white transition-transform duration-500 rounded-full bg-cyma-purple hover:scale-105 font-ubuntu"
  >
    <slot />
  </router-link>
</template>

<script setup>
defineProps({
  to: {
    type: Object,
    required: true,
  },
});
</script>
